import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextChip from './TextChip';

class AlertChip extends PureComponent {
    state = {};

    render() {
        const { name = '', className = '', ...rest } = this.props;

        const classes = ['react-chip-alert'];
        if (className) {
            classes.push(className);
        }

        return <TextChip className={classes.join(' ')} text={name} {...rest} />;
    }
}

AlertChip.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
};

export default AlertChip;
